import { initStackedBarChart } from 'vlcishared';
import {
  echartVerStackedBar,
  printDataChart,
  printNoDataChart,
} from '../common';

export function echartAccesosHorStackedBarVehicles(vis, datos) {
  if (datos.resultset.length === 0) {
    printNoDataChart(
      '#chartAccesosHorStackedBar',
      '#no_dataAccesosHorStackedBar',
    );
  } else {
    printDataChart(
      '#no_dataAccesosHorStackedBar',
      '#chartAccesosHorStackedBar',
    );
    const misDatosArray = datos.resultset;
    const updateOptions = {
      title: {
        text: 'ACCESSOS A LA CIUTAT: HISTÒRIC ANUAL',
      },
      color: [
        '#9c89b8',
        '#4ea8de',
        '#05668d',
        '#ffbf69',
        '#e56b6f',
        '#83c5be',
        '#02c39a',
        '#ee9b00',
        '#cdb4db',
        '#ffadad',
        '#ce4257',
        '#b7b7a4',
      ],
      xAxis: {
        name: '\n\n\n\nVehicles',
      },
    };
    initStackedBarChart(
      'chartAccesosHorStackedBar',
      misDatosArray,
      updateOptions,
    );
  }
}

export function echartAccesosVerStackedBarVehicles(vis, datos) {
  echartVerStackedBar(
    'chartAccesosStackedBar',
    'no_dataAccesosStackedBar',
    datos.resultset,
    'Vehicles',
    'ACCESSOS A LA CIUTAT: HISTÒRIC MENSUAL',
  );
}
